/* tslint:disable */
/* eslint-disable */
/* @relayHash 440f597642f3dcd200e6f5415918d59e */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type MessageBannerQueryVariables = {
    userId: string;
    hasRegisteredUserMessages: boolean;
    hasUnregisteredUserMessages: boolean;
    isFirstTimeVisitor: boolean;
    hasPreviewVariables: boolean;
    previewSetId: string;
    previewUserType: string;
};
export type MessageBannerQueryResponse = {
    readonly viewer: {
        readonly user?: {
            readonly registeredUserMessages: ReadonlyArray<{
                readonly " $fragmentRefs": FragmentRefs<"MessageBannerCarousel_messages">;
            } | null> | null;
        } | null;
        readonly unregisteredUserMessages?: ReadonlyArray<{
            readonly " $fragmentRefs": FragmentRefs<"MessageBannerCarousel_messages">;
        } | null> | null;
        readonly previewMessages?: ReadonlyArray<{
            readonly " $fragmentRefs": FragmentRefs<"MessageBannerCarousel_messages">;
        } | null> | null;
    };
};
export type MessageBannerQuery = {
    readonly response: MessageBannerQueryResponse;
    readonly variables: MessageBannerQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasRegisteredUserMessages",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasUnregisteredUserMessages",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isFirstTimeVisitor",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasPreviewVariables",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "previewSetId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "previewUserType",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v2 = [
  {
    "kind": "FragmentSpread",
    "name": "MessageBannerCarousel_messages",
    "args": null
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "isFirstTimeVisitor",
    "variableName": "isFirstTimeVisitor"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "setId",
    "variableName": "previewSetId"
  },
  {
    "kind": "Variable",
    "name": "userType",
    "variableName": "previewUserType"
  }
],
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "content",
  "storageKey": null,
  "args": null,
  "concreteType": "MarketingMessageContent",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "message",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "cta",
      "storageKey": null,
      "args": null,
      "concreteType": "MarketingMessageCta",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "text",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "url",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
},
v8 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "userType",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "items",
    "storageKey": null,
    "args": null,
    "concreteType": "MessageSetItem",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "impressionCap",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "note",
        "storageKey": null,
        "args": null,
        "concreteType": "MarketingMessage",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "anchors",
            "storageKey": null,
            "args": null,
            "concreteType": "MarketingMessage",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v5/*: any*/)
            ]
          },
          (v5/*: any*/)
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "MessageBannerQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasRegisteredUserMessages",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": (v1/*: any*/),
                "concreteType": "User",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": "registeredUserMessages",
                    "name": "bannerMessages",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MessageSetModule",
                    "plural": true,
                    "selections": (v2/*: any*/)
                  }
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUnregisteredUserMessages",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "unregisteredUserMessages",
                "name": "messageSet",
                "storageKey": null,
                "args": (v3/*: any*/),
                "concreteType": "MessageSetModule",
                "plural": true,
                "selections": (v2/*: any*/)
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasPreviewVariables",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "previewMessages",
                "name": "messageSet",
                "storageKey": null,
                "args": (v4/*: any*/),
                "concreteType": "MessageSetModule",
                "plural": true,
                "selections": (v2/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "MessageBannerQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasRegisteredUserMessages",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": (v1/*: any*/),
                "concreteType": "User",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": "registeredUserMessages",
                    "name": "bannerMessages",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MessageSetModule",
                    "plural": true,
                    "selections": (v8/*: any*/)
                  },
                  (v5/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUnregisteredUserMessages",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "unregisteredUserMessages",
                "name": "messageSet",
                "storageKey": null,
                "args": (v3/*: any*/),
                "concreteType": "MessageSetModule",
                "plural": true,
                "selections": (v8/*: any*/)
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasPreviewVariables",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "previewMessages",
                "name": "messageSet",
                "storageKey": null,
                "args": (v4/*: any*/),
                "concreteType": "MessageSetModule",
                "plural": true,
                "selections": (v8/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "MessageBannerQuery",
    "id": "ferrum/255.0.0-2020-03-10T14:28:54.909Z/MessageBannerQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'df6e26acec119bf8a391d14eabb41d7c';
export default node;
